import { makeStyles, Theme, createStyles } from "@material-ui/core/styles"

export const HeaderStyles = makeStyles((theme: Theme) => createStyles({
	headContainer: {
		position: "fixed",
		top: 0,
		left: 0,
		width: "100%",
		background: theme.palette.common.white,
		zIndex: 9
	},

	headContainerinr: {
		display: "flex",
		padding: "0 16px",
		justifyContent: "space-between",
		fontFamily: theme.typography.fontFamily,
	},
	driverLogo: {
		"& .extcustomIcon": {
			width: "100%",
			maxWidth: 165,
			height: 68,
		}
	},
	callInformation: {
		display: "flex",
		alignItems: "center",
		flexDirection: "column",
		justifyContent: "center",
		"& a": {
			color: theme.palette.text.primary,
			textDecoration: "none"
		},
		"& .spanTitle": {
			fontWeight: 400,
			fontSize:12
		}
	},
	headDivider: {
	},
	avatharCls: {
		width: 40,
		margin: "0 auto"
	},
	profilesection: {

	},
	profileavatar: {
		textAlign: "center",
		"& .extcustomIcon": {
			height: 30,
		}
	},
	profilename: {
		marginTop: 4,
		fontSize: 12,
		textAlign: "center",
		textTransform: "uppercase",
	},
	help: {
		cursor: "pointer",
		width: 40,
	},
	linearProgressMain: {
		backgroundColor: "#dddddd !important",
	},
	linearProgressPrimary: {
		backgroundColor: "#0b9a64 !important",
	},
	linearProgressDeterminate: {
		height: "6px !important",
	},
	linearProgressbar1Determinate: {
		borderRadius: 8
	}

}));